// extracted by mini-css-extract-plugin
export default {"disabled":"sSAcJWzl3DA4BlruOKOy"};